import { Typography } from '@/components/atoms/Typography';
import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';

interface LoadingScreenProps {
    message?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
    message = 'Loading...'
}) => {
    const colors = useUIColors();

    return (
        <View style={[styles.container, { backgroundColor: colors.backgroundLevel1 }]}>
            <Typography variant="body" color="primary">
                {message}
            </Typography>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
});
